<script lang="ts">
  type AiContext = {
    business_name?: string
    business_description?: string
    hours?: string
    key_information?: string
    off_limits_topics?: string
    persona?: string
  }

  type AiResponse = {
    active: boolean
    text: string
    ai_context: AiContext
  }

  let { aiResponse = $bindable() } = $props<{ aiResponse: AiResponse }>()
</script>

<div class="panel panel--padded shaded">
  <div class="panel-heading">
    AI Responder
  </div>

  <div class="panel-body">
    <div class="panel--well mt-1">
      <div class="row">
        <div class="col-sm-10">
          <h4>
            Enable AI Responder?
          </h4>
          <small class="help-block mb-0">
            This feature costs one credit per response.
          </small>
        </div>
        <div class="col-sm-2 text-right">
          <label class="block mb-0">
            <input type="checkbox"
                   class="switch-checkbox"
                   bind:checked={aiResponse.active}
            />
            <span class="switch"></span>
          </label>
        </div>
      </div>
    </div>

    <p class="help-block mt-1">
      Tell us how the assistant should respond when customers text in. We'll use this to draft replies on the fly.
    </p>

    <div class="form-group mt-1">
      <label for="ai-business-name" class="control-label">Business name</label>
      <input
        id="ai-business-name"
        type="text"
        class="form-control"
        bind:value={aiResponse.ai_context.business_name}
      />
      <div class="help-block">What's the name customers see?</div>
    </div>

    <div class="form-group mt-1">
      <label for="ai-business-description" class="control-label">Describe your business</label>
      <textarea
        id="ai-business-description"
        class="form-control"
        rows="2"
        bind:value={aiResponse.ai_context.business_description}
      ></textarea>
      <div class="help-block">e.g., cuisine type, location, vibe</div>
    </div>

    <div class="form-group mt-1">
      <label for="ai-hours" class="control-label">Hours of operation</label>
      <textarea
        id="ai-hours"
        class="form-control"
        rows="2"
        bind:value={aiResponse.ai_context.hours}
      ></textarea>
      <div class="help-block">Freeform, e.g., "Mon-Sat 11a-10p, closed Sun"</div>
    </div>

    <div class="form-group mt-1">
      <label for="ai-key-information" class="control-label">What should the assistant know?</label>
      <textarea
        id="ai-key-information"
        class="form-control"
        rows="5"
        bind:value={aiResponse.ai_context.key_information}
      ></textarea>
      <div class="help-block">Menu items, prices, parking, FAQs — paste freely</div>
    </div>

    <div class="form-group mt-1">
      <label for="ai-off-limits-topics" class="control-label">What should the assistant never discuss?</label>
      <textarea
        id="ai-off-limits-topics"
        class="form-control"
        rows="2"
        bind:value={aiResponse.ai_context.off_limits_topics}
      ></textarea>
      <div class="help-block">Topics to avoid (optional)</div>
    </div>

    <div class="form-group mt-1">
      <label for="ai-fallback" class="control-label">Fallback message</label>
      <input
        id="ai-fallback"
        type="text"
        class="form-control"
        bind:value={aiResponse.text}
      />
      <div class="help-block">Sent when the assistant isn't sure. Keep it short — fits in one SMS.</div>
    </div>

    <div class="form-group mt-1">
      <label for="ai-persona" class="control-label">Tone / personality</label>
      <input
        id="ai-persona"
        type="text"
        class="form-control"
        bind:value={aiResponse.ai_context.persona}
      />
      <div class="help-block">e.g., "warm and friendly", "professional", "casual"</div>
    </div>
  </div>
</div>
